/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { ETableEditAction } from "../../../Utils/Enums";
import MUIDataTableCustomStyle from "../../MUIDataTableCustomStyle";
import { endpoints } from "../../../Utils/UrlEnum";
import { useParams } from "react-router-dom";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { formatDate, getFullName } from "../../../Utils/Utils";
import { PaymentsListProps } from "../../../Utils/Types";

export default function PaymentsListTable(props: PaymentsListProps) {
  const { id } = useParams();
  const endPointUrl = `${endpoints.payments.forOrder}/${id}`;
  const { triggerReload } = props;

  const columns = [
    {
      name: "incrementId",
      label: "ID",
      options: {
        sort: false,
      },
    },
    {
      name: "orderId",
      label: Vocabulary.account,
      options: {
        sort: false,
        customBodyRender: (order: any) => {
          return order?.client_id?.workPointId?.name;
        },
      },
    },
    {
      name: "signedAmount",
      label: Vocabulary.pay,
      options: {
        sort: false,
      },
    },
    {
      name: "paymentMethod",
      label: Vocabulary.paymentMethod,
      options: {
        sort: false,
      },
    },
    {
      name: "description",
      label: Vocabulary.payemntNote,
      options: {
        sort: false,
      },
    },
     {
      name: "createdByUserId",
      label: Vocabulary.createdBy,
      options: {
        sort: false,
        customBodyRender: (user: any) => {
          return getFullName(user);
        }
      },
    },
    {
      name: "createdAt",
      label: Vocabulary.createdAt,
      options: {
        sort: false,
        customBodyRender: (date: any) => {
          return formatDate(date);
        },
      },
    },
  ];
  /**
   *
   */
  return (
    <div>
      <MUIDataTableCustomStyle
        CRUDEndPoint={endPointUrl}
        title={""}
        onEditAction={ETableEditAction.NONE}
        columns={columns}
        hideEditButton
        hideDeleteButton
        hideAddButton
        hideSearch
        triggerReload={triggerReload}
      />
    </div>
  );
}
